import React from 'react';
import { Typography, Button, Box, Container } from '@mui/material';
import { motion } from 'framer-motion';
import desktopDashboard from '../assets/desktop-page.png';

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.9,
      delay: i * 0.2,
      ease: [0.25, 0.1, 0.25, 1],
    },
  }),
};

const scaleIn = {
  hidden: { opacity: 0, scale: 0.92 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 1.1,
      ease: [0.25, 0.1, 0.25, 1],
    },
  },
};

const HeroSection = () => {
  return (
    <Box
      component="section"
      sx={{
        position: 'relative',
        overflow: 'hidden',
        width: '100%',
        background: 'linear-gradient(180deg, #f2f6fa 0%, #e2edf5 40%, #d5e8ef 100%)',
        pt: { xs: 10, sm: 14, md: 18 },
        pb: { xs: 8, sm: 12, md: 16 },
      }}
    >
      <Container maxWidth="md">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-80px' }}
          custom={0}
        >
          <Typography
            variant="h1"
            sx={{
              fontWeight: 700,
              lineHeight: 1.05,
              fontSize: 'clamp(2.8rem, 4.5vw + 1rem, 5.5rem)',
              letterSpacing: '-0.035em',
              mb: { xs: 3, md: 4 },
              color: '#1d1d1f',
              textAlign: 'center',
              maxWidth: '900px',
              mx: 'auto',
            }}
          >
            Kenya’s #1 ISP Billing Software for{' '}
            <Box
              component="span"
              sx={{
                background: 'linear-gradient(135deg, #19b594 0%, #0b74c1 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                display: 'inline',
                whiteSpace: 'nowrap',
              }}
            >
              Hotspot & PPPoE
            </Box>
          </Typography>
        </motion.div>

        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-80px' }}
          custom={1}
        >
          <Typography
            sx={{
              fontWeight: 400,
              lineHeight: 1.6,
              fontSize: 'clamp(1.1rem, 0.5vw + 0.5rem, 1.4rem)',
              letterSpacing: '0.005em',
              mb: { xs: 5, md: 6 },
              color: 'rgba(29,29,31,0.7)',
              textAlign: 'center',
              maxWidth: '680px',
              mx: 'auto',
            }}
          >
            Automate billing, payments, SMS alerts, and router management for your ISP.
          </Typography>
        </motion.div>

        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-80px' }}
          custom={2}
          style={{ display: 'flex', justifyContent: 'center' }}
        >
          <Button
            variant="contained"
            size="large"
            href="#contact"
            sx={{
              fontSize: 'clamp(1rem, 0.3vw + 0.4rem, 1.15rem)',
              fontWeight: 500,
              letterSpacing: '-0.005em',
              px: { xs: 4, sm: 5, md: 6 },
              py: { xs: 1.5, sm: 1.75, md: 2 },
              background: 'linear-gradient(135deg, #0a66bb 0%, #19b594 100%)',
              color: '#fff',
              borderRadius: 980,
              textTransform: 'none',
              boxShadow: '0 8px 24px rgba(10,102,187,0.25)',
              transition: 'all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
              '&:hover': {
                background: 'linear-gradient(135deg, #0b74c1 0%, #219cac 100%)',
                transform: 'scale(1.03)',
                boxShadow: '0 12px 32px rgba(10,102,187,0.35)',
              },
            }}
          >
            Get Started Now
          </Button>
        </motion.div>
      </Container>

      <Container
        maxWidth="lg"
        sx={{
          mt: { xs: 6, sm: 8, md: 12 },
          display: 'flex',
          justifyContent: 'center',
          px: { xs: 2, sm: 3, md: 4 },
        }}
      >
        <motion.div
          variants={scaleIn}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
          style={{ width: '100%', display: 'flex', justifyContent: 'center' }}
        >
          <Box
            component="img"
            src={desktopDashboard}
            alt="NasRadius Desktop Dashboard"
            loading="lazy"
            sx={{
              width: '100%',
              maxWidth: { xs: '100%', sm: '95%', md: '92%', lg: '88%' },
              height: 'auto',
              display: 'block',
              borderRadius: { xs: 12, sm: 16, md: 20 },
              boxShadow: '0 30px 60px rgba(0,0,0,0.12), 0 10px 30px rgba(0,0,0,0.06)',
              transition: 'box-shadow 0.5s ease',
              '&:hover': {
                boxShadow: '0 40px 80px rgba(0,0,0,0.16), 0 15px 40px rgba(0,0,0,0.08)',
              },
            }}
          />
        </motion.div>
      </Container>
    </Box>
  );
};

export default HeroSection;
